"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseError_1 = require("./BaseError");
var SimpleAPIParserError = /** @class */ (function (_super) {
    __extends(SimpleAPIParserError, _super);
    /**
     *  Creates a new SimpleAPIParserError
     * @param message {string} The message about the error.
     * @param response {AxiosResponse} the response the parser
     * failed to parse.
     */
    function SimpleAPIParserError(message, response) {
        var _this = _super.call(this, message) || this;
        _this.response = response;
        return _this;
    }
    /**
     * If this error is regarded as a recoverable error
     * @returns {boolean}
     */
    SimpleAPIParserError.prototype.isRecoverable = function () {
        return false;
    };
    SimpleAPIParserError.prototype.getResponse = function () {
        return this.response;
    };
    /**
     * Gets the status code attributed with this error
     */
    SimpleAPIParserError.prototype.getStatusCode = function () {
        return "000";
    };
    return SimpleAPIParserError;
}(BaseError_1.BaseError));
exports.SimpleAPIParserError = SimpleAPIParserError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2ltcGxlQVBJUGFyc2VyRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvQVBJL1NpbXBsZUFQSS9FcnJvcnMvU2ltcGxlQVBJUGFyc2VyRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQ0EseUNBQXdDO0FBRXhDO0lBQTBDLHdDQUFTO0lBR2pEOzs7OztPQUtHO0lBQ0gsOEJBQVksT0FBZSxFQUFFLFFBQXVCO1FBQXBELFlBQ0Usa0JBQU0sT0FBTyxDQUFDLFNBRWY7UUFEQyxLQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQzs7SUFDM0IsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDRDQUFhLEdBQXBCO1FBQ0UsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0lBRU0sMENBQVcsR0FBbEI7UUFDRSxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUM7SUFDdkIsQ0FBQztJQUVEOztPQUVHO0lBQ0ksNENBQWEsR0FBcEI7UUFDRSxPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFDSCwyQkFBQztBQUFELENBQUMsQUFoQ0QsQ0FBMEMscUJBQVMsR0FnQ2xEO0FBaENZLG9EQUFvQiJ9